import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRevenueIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 145,
	height: 145,
	viewBox: "0 0 145 145",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M72.395 143.435C111.629 143.435 143.435 111.629 143.435 72.395C143.435 33.1607 111.629 1.35498 72.395 1.35498C33.1606 1.35498 1.35498 33.1607 1.35498 72.395C1.35498 111.629 33.1606 143.435 72.395 143.435Z",
			stroke: "white",
			strokeWidth: 2.71,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.875 82.835C56.605 89.335 61.545 95.645 71.895 95.645C82.235 95.645 86.995 89.785 86.995 83.475C86.995 77.435 84.065 73.865 72.255 71.025L70.605 70.585C58.795 67.745 55.865 64.175 55.865 58.135C55.865 52.095 60.625 45.965 70.965 45.965C81.305 45.965 86.245 52.285 86.985 58.775",
			stroke: "white",
			strokeWidth: 6.66,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71.4348 35.925V45.965",
			stroke: "white",
			strokeWidth: 6.66,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71.4348 98.005V108.045",
			stroke: "white",
			strokeWidth: 6.66,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgRevenueIcon;
